const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e0cbf05ce33cbb0a307cd77b6b7584fd.jpg"
          alt="ES Bilgisayar - 2. El Bilgisayar ve Teknik Servis"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 lg:px-8 py-32">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/95 backdrop-blur-sm rounded-full mb-8">
            <i className="ri-award-line text-secondary text-lg"></i>
            <span className="text-sm font-semibold text-primary">15+ Yıllık Deneyim</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight font-heading">
            Güvenilir 2. El Bilgisayar Alım Satım ve Profesyonel Teknik Servis
          </h1>

          {/* Subheading */}
          <p className="text-lg lg:text-xl text-white/90 mb-10 leading-relaxed max-w-3xl">
            İkinci el laptop ve masaüstü bilgisayar alım-satımında uzman kadro. Hızlı bilgisayar tamiri, laptop tamiri, uygun fiyat ve garantili hizmet ile yanınızdayız. Bilgisayar bakım ve onarım konusunda profesyonel çözümler sunuyoruz.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mb-12">
            <a
              href="tel:+905065376985"
              className="flex items-center justify-center space-x-3 px-8 py-4 bg-secondary hover:bg-secondary-dark text-white rounded-lg font-semibold text-base shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Hemen Ara: 0506 537 69 85</span>
            </a>
            <a
              href="https://wa.me/905065376985"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-3 px-8 py-4 bg-whatsapp hover:bg-whatsapp/90 text-white rounded-lg font-semibold text-base shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>WhatsApp ile İletişim</span>
            </a>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm px-5 py-3 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center bg-secondary/20 rounded-lg">
                <i className="ri-check-line text-secondary text-xl"></i>
              </div>
              <span className="text-white font-medium text-sm">Ücretsiz Ön İnceleme</span>
            </div>
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm px-5 py-3 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center bg-secondary/20 rounded-lg">
                <i className="ri-time-line text-secondary text-xl"></i>
              </div>
              <span className="text-white font-medium text-sm">Aynı Gün Servis</span>
            </div>
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm px-5 py-3 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center bg-secondary/20 rounded-lg">
                <i className="ri-shield-check-line text-secondary text-xl"></i>
              </div>
              <span className="text-white font-medium text-sm">Garantili İşlem</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-col items-center space-y-2 animate-bounce">
          <span className="text-white/80 text-sm font-medium">Keşfet</span>
          <i className="ri-arrow-down-line text-white/80 text-2xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;